import { Lessons } from '../Lessons/Lessons'

export const LessonsPage = () => <Lessons />
